import React from "react";
import { IMAGES } from "../mock";
import { ButtonLink, Kicker, SectionHeading } from "../components/UI";
import { PageHero } from "./FindRenovate";
import { useReveal } from "../hooks/useReveal";
import { useSiteImages } from "../context/SiteImages";

const PHILOSOPHY = ["A dated kitchen can change.", "A poor layout can change.", "Old flooring can change.", "Paint can change.", "Fixtures can change."];

export default function About() {
  const ref = useReveal();
  const { simg } = useSiteImages();
  return (
    <div ref={ref}>
      <PageHero
        kicker="About KRS"
        title={<>We Believe the Right Home Isn't Always Found. <span className="text-gold-soft italic">Sometimes It's Created.</span></>}
        image={IMAGES.dining2}
        imageKey="hero_about"
      />

      <section className="py-24 md:py-32 bg-cream">
        <div className="max-w-[1440px] mx-auto px-6 lg:px-12 grid grid-cols-1 lg:grid-cols-12 gap-16 items-start">
          <div className="lg:col-span-5">
            <SectionHeading kicker="Our Story" title="A More Connected Experience." className="reveal" />
            <img src={simg("about_story", IMAGES.materials3)} alt="Design details" className="reveal w-full h-80 object-cover mt-10" />
          </div>
          <div className="lg:col-span-6 lg:col-start-7 space-y-5 font-sans text-lg text-charcoal/70 leading-relaxed font-light reveal">
            <p>Buying or renovating a home is one of the biggest investments most people will ever make. And yet the process is often fragmented — one professional to find the property, another to design it, another to renovate it.</p>
            <p>We saw an opportunity to create a more connected experience. Our approach brings together <span className="text-navy font-normal">real estate knowledge, design vision, and renovation execution</span> so clients can make better decisions from the beginning.</p>
            <p>For buyers, that means helping you recognize homes with potential that others may overlook. For homeowners, it means helping you rethink your existing home and uncover possibilities you may never have considered.</p>
            <p className="font-serif italic text-2xl text-gold not-italic"><span className="italic">Our job is the same: understand your vision, see the potential, and help bring it to life.</span></p>
          </div>
        </div>
      </section>

      <section className="py-24 md:py-32 bg-navy text-cream">
        <div className="max-w-4xl mx-auto px-6 lg:px-12 text-center">
          <SectionHeading dark kicker="Our Philosophy" title="See Beyond What Exists Today." center className="reveal" />
          <div className="reveal mt-12 flex flex-wrap justify-center gap-x-8 gap-y-4">
            {PHILOSOPHY.map((p) => (
              <span key={p} className="font-serif text-2xl md:text-3xl text-cream/60">{p}</span>
            ))}
          </div>
          <p className="reveal font-serif italic text-gold-soft text-3xl mt-10 leading-snug">What matters most is finding the right foundation and having a clear vision for what comes next.</p>
          <div className="reveal flex justify-center mt-10"><ButtonLink to="/contact" variant="gold">Start Your Project</ButtonLink></div>
        </div>
      </section>
    </div>
  );
}
